import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { Badge } from '@winnin/winnin_ui.components.badge'
import { Card } from '@winnin/winnin_ui.components.card'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { ProviderIcon } from '@winnin/winnin_ui.components.provider-icon'
import { Title } from '@winnin/winnin_ui.components.title'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import BioCard from 'components/BioCard'
import CreatorCardOnHover from 'components/CreatorCardOnHover'
import LivePostTag from 'components/LivePostTag'
import MetricsCard from 'components/MetricsCard'
import VideoEmbed from 'components/VideoContent/components/VideoEmbed'
import { PROVIDERS } from 'consts'
import { T, useTranslate } from 'lib/tolgee'
import { formatDate, TOLGEE_GLOBALS } from 'utils'
import './index.scss'

dayjs.extend(duration)

function PublicVideoContent({ video }) {
  const {
    engagement,
    provider,
    videoUrl,
    views,
    title,
    comments,
    description,
    likes,
    publishedAt,
    engagementRatio,
    postId,
    postUrl,
    creatorId,
    thumbnail,
    creator,
    isPublicity,
    live,
    hasViewsReaction,
    hasCommentsReaction,
    hasLikesReaction,
    isLikesReactionDisabled,
  } = video ?? {}

  const providerName = PROVIDERS?.[provider]?.NAME
  const videoMetrics = {
    likes,
    description,
    publishedAt,
    comments,
    views,
    engagement,
    engagementRatio,
    info: {
      hasViewsReaction,
      hasLikesReaction,
      isLikesReactionDisabled,
      hasCommentsReaction,
    },
  }
  const t = useTranslate()

  return (
    <div className="PublicVideoContent">
      <div className="modal-content">
        <div className="video-modal-container">
          <VideoEmbed
            creatorId={creatorId}
            postId={postId}
            postUrl={postUrl}
            provider={provider}
            thumbnail={thumbnail}
            title={title}
            videoUrl={videoUrl}
          />

          <div className="video-modal-content">
            <div className="info-content-grid">
              <Card className="video-info">
                <div className="video-info-addto-title">
                  <Title tag="h3" className="title">
                    {title}
                  </Title>
                </div>

                <div className="content">
                  <div className="video-info-top">
                    <div className="video-creator">
                      <div className={`provider`}>
                        {providerName !== undefined && (
                          <ProviderIcon
                            icon={provider}
                            height={provider === 'yt' ? 20 : 26}
                            width={provider === 'yt' ? 29 : 26}
                          />
                        )}
                      </div>

                      <span className="video-creator-label">by </span>

                      <div className="video-creator-link video-creator-link-public">
                        {creator && (
                          <CreatorCardOnHover
                            videoTitle={title}
                            type={creator?.__typename}
                            noHover
                            noLink
                            title={creator?.title}
                            id={creatorId}
                            provider={provider}
                            groupId={creator?.groupId}
                          />
                        )}
                      </div>
                    </div>

                    {publishedAt && (
                      <div className="published-at">
                        <T keyName="PublicVideoContent-labelPublished">Published</T>: {formatDate(publishedAt)}
                      </div>
                    )}
                  </div>
                  <div className="content-ads-live-wrapper">
                    {isPublicity && (
                      <TooltipWrapper tooltipMessage={t(TOLGEE_GLOBALS.paidPartnership)} tooltipStyle="tooltippedE">
                        <Badge colorScheme="yellow" className="YellowBadge-customStyle">
                          <Icon icon="ads" fill="var(--base_color1)" width={11} height={16} />
                        </Badge>
                      </TooltipWrapper>
                    )}
                    {live && (
                      <Card className="live-state">
                        <LivePostTag live={live} isCard={false} />
                      </Card>
                    )}
                  </div>
                </div>
              </Card>

              <MetricsCard metrics={videoMetrics} provider={provider} loading={false} className="video-modal-about" />

              {provider === 'yt' && description?.length > 0 && <BioCard content={description} loading={false} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicVideoContent
